/**
 * Shared constants for useOracleSearch and useOracleSearchStream.
 *
 * These were previously duplicated in both hooks.
 */

import type { OracleSearchResults, OracleSearchType } from './useOracleSearch'

export const EMPTY_RESULTS: OracleSearchResults = {
  playlists: [],
  content: [],
  profiles: [],
}

export const DEFAULT_TYPES: OracleSearchType[] = ['content', 'playlist']
